// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { externalLinkOpen } from '../../../../actions/externallink';
import { RedirectServices, getRedirectUrl } from '../../../../config/urls';
import useMergeProps from '../../../../hooks/useMergeProps';
import { __ } from '../../../../i18n/l10n';
import { useBoomContext } from '../../contexts/BoomContext';
import { selectBoomGlobalBoomId } from '../../selectors/global/globalPrimary.selector';
import BoomPrimaryButton from '../common/BoomPrimaryButton';

const RulesButton = styled(BoomPrimaryButton)`
  margin-left: auto;
`;

type PropsType = {
  className?: string;
};

const BoomRulesButtonContainer = (ownProps: PropsType) => {
  const dispatch = useDispatch();
  const { skinId } = useBoomContext();
  const boomId = useSelector(selectBoomGlobalBoomId);

  const onClick = useCallback(() => {
    dispatch(externalLinkOpen(getRedirectUrl(RedirectServices.BOOM_RULES, { boomId })));
  }, [dispatch, boomId]);

  const otherProps = useMemo(() => ({ skinId, onClick }), [skinId, onClick]);

  const enhancedProps = useMergeProps({ ownProps, otherProps });

  return (
    <RulesButton {...enhancedProps} variant="secondary" isSmall>
      {__('!noun:Rules')}
    </RulesButton>
  );
};

export default BoomRulesButtonContainer;
